import { Box } from "@mui/joy";
import { useNavigate } from "react-router-dom";

import { useAuthentication } from "../../hooks/query";
import { useAuth } from "../../hooks";
import { useEffect } from "react";
import { clearAuthSession } from "../../utils/offlineAuthSession";

export default function Logout() {
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser, setRoles, setOrganizations, setToken } = useAuth();
    const { useLogout } = useAuthentication();
    const logoutSvc = useLogout();

    const fetchData = async () => {
        try {
            await logoutSvc.mutateAsync({});
        } catch (error) {
            console.log(error);
        } finally {
            await clearAuthSession();
            setUser(null);
            setRoles([]);
            setOrganizations([]);
            setToken("");
            setIsAuthenticated(false);
            sessionStorage.removeItem("selectedOrganizationId");
            navigate("/auth/landing");
        }
    };

    useEffect(() => {
        fetchData().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Box>Logging out...</Box>;
}
